module.exports = __webpack_public_path__ + "img/tanja_korb_cropped.80a616cb.jpg";